import { call, delay, put } from 'redux-saga/effects'
import get from 'lodash/get'

import { push } from 'connected-react-router'

import { Action } from '../../types'
import { ClientChecksRoutes } from '../../constants/enums'
import { POOLING_DELAY_CLIENT_CHECK } from '../../constants/commonConstants'
import { modalLoaderActions, requirementActions } from '../../redux'
import { OpenApiInterface } from '../../api/requests/openApi'
import { Response } from '../../api/api'
import { Saga } from '../../types/form'
import Routes from '../../constants/routes'

export function* getListOfRequirements(api: OpenApiInterface, action: Action<any>): Saga {
  const loader: any = yield put(modalLoaderActions.showModalLoader())
  const response = yield call(api.getListOfRequirements)

  if (response.responseStatus === Response.ok) {
    const responseData: any = response.data
    const nextUrl = get(ClientChecksRoutes, responseData.nextStep, null)

    yield put(requirementActions.storeListOfRequirements({ ...responseData, nextUrl }))
    yield put(modalLoaderActions.hideModalLoader(loader.id))

    if (responseData.status === 'NOK') {
      action.payload.deny()
    } else if (nextUrl === Routes.FINAL) {
      yield put(push(nextUrl))
    } else if (responseData.displayPollingWarning) {
      yield delay(POOLING_DELAY_CLIENT_CHECK)
      yield put(action)
    }
  } else {
    yield put(modalLoaderActions.hideModalLoader(loader.id))
    action.payload.error({ type: response.responseStatus })
  }
}
